export default __webpack_public_path__ + "static/media/uzbekistan.dd24581f.svg";